import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import PatientHeader from './components/PatientHeader';
import RecordTabs from './components/RecordTabs';
import OverviewTab from './components/OverviewTab';
import ConsultationsTab from './components/ConsultationsTab';
import LabResultsTab from './components/LabResultsTab';
import PrescriptionsTab from './components/PrescriptionsTab';
import CredentialsTab from './components/CredentialsTab';
import DocumentsTab from './components/DocumentsTab';

const PatientRecords = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  // Mock patient data
  const patient = {
    id: "PAT-2025-001",
    name: "Emily Rodriguez",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
    status: "Active",
    dateOfBirth: "1985-03-15",
    gender: "Female",
    bloodType: "A+",
    phone: "(555) 123-4567",
    email: "emily.rodriguez@email.com",
    address: "123 Main St, Springfield, IL 62701",
    emergencyContact: {
      name: "Michael Rodriguez",
      relationship: "Spouse",
      phone: "(555) 987-6543"
    },
    insurance: {
      provider: "BlueCross BlueShield",
      policyNumber: "BCBS-2025-789456",
      group: "GRP-12345"
    }
  };

  // Tab counts for navigation
  const tabCounts = {
    consultations: 12,
    labResults: 8,
    prescriptions: 6,
    credentials: 4,
    documents: 15
  };

  const handleEditPatient = () => {
    console.log('Edit patient:', patient?.id);
    // Navigate to edit patient form or open modal
  };

  const handleViewCredentials = () => {
    setActiveTab('credentials');
  };

  const handleNewConsultation = () => {
    navigate('/video-consultation');
  };

  const handleUploadResult = () => {
    console.log('Upload lab result');
    // Open upload modal or navigate to upload page
  };

  const handleOrderLab = () => {
    console.log('Order new lab');
    // Navigate to lab order page or open modal
  };

  const handleNewPrescription = () => {
    navigate('/prescription-management');
  };

  const handleIssueCredential = () => {
    navigate('/credential-wallet');
  };

  const handleVerifyCredential = () => {
    navigate('/verification-portal');
  };

  const handleUploadDocument = () => {
    console.log('Upload document');
    // Open upload modal or file picker
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab patient={patient} />;
      case 'consultations':
        return <ConsultationsTab onNewConsultation={handleNewConsultation} />;
      case 'lab-results':
        return <LabResultsTab onUploadResult={handleUploadResult} onOrderLab={handleOrderLab} />;
      case 'prescriptions':
        return <PrescriptionsTab onNewPrescription={handleNewPrescription} />;
      case 'credentials':
        return <CredentialsTab onIssueCredential={handleIssueCredential} onVerifyCredential={handleVerifyCredential} />;
      case 'documents':
        return <DocumentsTab onUploadDocument={handleUploadDocument} />;
      default:
        return <OverviewTab patient={patient} />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <button 
                onClick={() => navigate('/provider-dashboard')}
                className="hover:text-foreground transition-clinical"
              >
                Dashboard
              </button>
              <span>/</span>
              <span className="text-foreground">Patient Records</span>
            </div>
            <h1 className="text-3xl font-bold text-foreground">Patient Records</h1>
            <p className="text-muted-foreground mt-2">
              Comprehensive health information management with FHIR-compliant data handling and blockchain verification
            </p>
          </div>

          {/* Patient Header */}
          <div className="mb-8">
            <PatientHeader 
              patient={patient}
              onEditPatient={handleEditPatient}
              onViewCredentials={handleViewCredentials}
            />
          </div>

          {/* Record Tabs */}
          <div className="mb-6">
            <RecordTabs 
              activeTab={activeTab}
              onTabChange={setActiveTab}
              tabCounts={tabCounts}
            />
          </div>

          {/* Tab Content */}
          <div className="min-h-[600px]">
            {renderTabContent()}
          </div>
        </div>
      </main>
    </div>
  );
};

export default PatientRecords;